<template>
    <confirmation-page-layout :company="company" :loaded="loaded" :tourlead="tourlead">
        <template v-slot:breadcrumbs>
            <simple-tour-breadcrumbs :search-request="searchRequest" :product="product" />
        </template>
        <template v-slot:sidebar>
            <simple-tour-search-summary search-disabled :search-request="searchRequest" />
            <simple-tour-order-summary
                :offer="offer"
                :product="product"
                :prebooked="!!bookingKey"
                :info="basketItem.info"
                :extra-services="extraServices"
                :search-request="searchRequest"
                :additional-options="bookingAdditionalOptions"
            >
                <template v-slot:summary>
                    <v-card flat rounded="0" class="my-2 pa-0">
                        <v-card-text class="pa-0">
                            <search-summary-content
                                :search-request="searchRequest"
                                :date-prop="offer.date"
                                tourists-label="guest"
                                show-date
                                show-tourists
                            />
                        </v-card-text>
                    </v-card>
                </template>
            </simple-tour-order-summary>
        </template>
    </confirmation-page-layout>
    <simple-tour-offer-info-modal />
    <conditions-modal>
        <template v-slot:info>
            <activity-conditions-modal-info />
        </template>
    </conditions-modal>
</template>

<script lang="ts">
    import {Component, mixins} from 'vue-facing-decorator'
    import ConfirmationPageLayout from '@/components/parts/ConfirmationPageLayout.vue'
    import {ConfirmationPageMixin} from '@/mixins/ConfirmationPageMixin.vue'
    import SimpleTourBreadcrumbs from '~/components/simpleTours/SimpleTourBreadcrumbs.vue'
    import SimpleTourOrderSummary from '~/components/simpleTours/booking/SimpleTourOrderSummary.vue'
    import {SimpleTourMixin} from '@/mixins/SimpleTourMixin.vue'
    import {SimpleTourPageMixin} from '@/components/simpleTours/mixins/SimpleTourPageMixin.vue'
    import SimpleTourOfferInfoModal from '@/components/simpleTours/info/SimpleTourOfferInfoModal.vue'
    import ConditionsModal from '@/components/modals/ConditionsModal.vue'
    import ActivityConditionsModalInfo from '~/components/activities/snippets/ActivityConditionsModalInfo.vue'
    import SearchSummaryContent from '@/components/parts/SearchSummaryContent.vue'
    import SimpleTourSearchSummary from '~/components/simpleTours/search/SimpleTourSearchSummary.vue'

    @Component({
        components: {
            SimpleTourSearchSummary,
            ActivityConditionsModalInfo,
            SimpleTourBreadcrumbs,
            SimpleTourOrderSummary,
            ConfirmationPageLayout,
            SimpleTourOfferInfoModal,
            ConditionsModal,
            SearchSummaryContent,
        },
        async setup() {
            return await useConfirmationPage()
        },
    })
    export class SimpleTourConfirmationPage extends mixins(
        ConfirmationPageMixin,
        SimpleTourPageMixin,
        SimpleTourMixin
    ) {
        get basketItem() {
            return simpleTourStore.basketItem(simpleTourStore.prepareBookRequest.offerKey)
        }

        get offer() {
            return this.basketItem.product.offers.find(
                offer => offer.offerKey === simpleTourStore.prepareBookRequest.offerKey
            )
        }

        get searchRequest() {
            return this.basketItem.searchRequest
        }

        get product() {
            return this.basketItem.product
        }
    }

    export default SimpleTourConfirmationPage
</script>
